// routes/PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { token, isInitializing } = useAuth();

  if (isInitializing) {
    return null;
  }

  return token ? children : <Navigate to="/login" replace />;
  
};

export default PrivateRoute;
